import './Info.css'

/**
 * "i"-ul de langa un nume. Balonul e cel al portalului - `data-toggle`,
 * `data-placement`, `title` - pus de `src/ui/tooltips.ts` (Bootstrap 3 fara
 * jQuery), nu un al doilea fel de a explica ceva. `role="img"` cu `aria-label`
 * fiindca `tooltips.ts` goleste `title` la prima trecere cu mausul, si fara el
 * textul ar disparea pentru cititorul de ecran.
 *
 * Nascut in Agent Modules (`DeviceAgentModules.tsx`, care il exporta mai
 * departe de aici); mutat in `ui/` cand l-au cerut si nivelurile de acces.
 */
export function Info({ what, text }: { what: string; text: string }) {
  return (
    <i
      className="fas fa-info-circle dam-i"
      data-toggle="tooltip"
      data-placement="top"
      data-level={what}
      title={text}
      role="img"
      aria-label={`${what}: ${text}`}
    ></i>
  )
}
